import ShipmentLabelUpload from '@components/shared/orders/ShipmentLabelUpload';
import useSmartBack from '@hooks/shared/useSmartBack';
import ListPageHeader from '@shared/ListPageHeader';
import { useTranslation } from 'react-i18next';

import { orderService } from '@services/admin/orderService';
import { fulfillmentService } from '@services/admin/fulfillmentService';

/**
 * Admin 頁面：上傳物流標籤
 */
export default function AdminUploadLabels() {
  const { t } = useTranslation();
  const goBack = useSmartBack();

  const handleSuccess = () => {
    goBack();
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['shipments', 'shipments.upload_labels']}
      />
      <ShipmentLabelUpload
        orderService={orderService}
        fulfillmentService={fulfillmentService}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
}
